"use client";

import { useEffect } from "react";
import { NextIntlClientProvider } from "next-intl";
import hr from "@/messages/hr.json";
import en from "@/messages/en.json";

export type Locale = "hr" | "en";

const MESSAGES: Record<Locale, typeof hr> = { hr, en };

export function LocaleProvider({ locale, children }: { locale: Locale; children: React.ReactNode }) {
  // The root <html lang> is fixed to "hr" (the /en tree is a nested layout,
  // not the true root, so it can't set the attribute itself). Correct it
  // client-side for the /en pages.
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return (
    <NextIntlClientProvider locale={locale} messages={MESSAGES[locale]}>
      {children}
    </NextIntlClientProvider>
  );
}
